import React from "react";

const HERO_BG =
  "https://images.pexels.com/photos/12627677/pexels-photo-12627677.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] bg-brand-teal text-white overflow-hidden grain"
    >
      {/* background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#061718]/95 via-[#0A2427]/85 to-[#154247]/70" />
        {/* corner grid */}
        <svg
          className="absolute inset-0 w-full h-full opacity-[0.06]"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern id="grid" width="48" height="48" patternUnits="userSpaceOnUse">
              <path d="M 48 0 L 0 0 0 48" fill="none" stroke="white" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-36 md:pt-44 pb-24 min-h-[100vh] flex flex-col justify-between">
        <div>
          <h1
            className="font-display text-5xl md:text-6xl lg:text-[88px] leading-[0.98] tracking-tighter max-w-5xl fade-up"
            data-testid="hero-headline"
          >
            Change doesn't<br />
            happen by itself.<br />
            <span className="text-[#2EC4B6]">We design it</span> with you,<br />
            <span className="text-[#2EC4B6]">always striving for more.</span>
          </h1>

          <p
            className="mt-10 max-w-xl text-lg md:text-xl text-white/70 leading-relaxed fade-up delay-200"
            data-testid="hero-subline"
          >
            A consulting partnership built on listening first, sharper thinking
            second, and the courage to keep striving for more — across every
            project, market and continent.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 fade-up delay-300">
            <a
              href="#divisions"
              data-testid="hero-cta-divisions"
              className="inline-flex items-center justify-center gap-3 px-7 py-4 bg-[#2EC4B6] text-[#0A2427] font-semibold tracking-tight hover:bg-white transition-colors duration-300"
            >
              Explore our divisions
              <span aria-hidden="true">→</span>
            </a>
            <a
              href="#vision"
              data-testid="hero-cta-vision"
              className="inline-flex items-center justify-center gap-3 px-7 py-4 border border-white/30 hover:border-white text-white font-medium transition-all"
            >
              Our philosophy
            </a>
          </div>
        </div>

        {/* bottom strip */}
        <div className="hidden md:grid grid-cols-4 gap-8 mt-24 fade-up delay-400 border-t border-light-translucent pt-8">
          {[
            ["04", "Divisions"],
            ["03", "Continents"],
            ["16+", "Marquee clients"],
            ["100%", "Partnership-led"],
          ].map(([n, l]) => (
            <div key={l} data-testid={`hero-stat-${l.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="font-display text-4xl text-white">{n}</div>
              <div className="overline text-muted-light mt-2">{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-8 right-6 md:right-12 z-10 hidden md:flex items-center gap-3 text-white/50 text-xs">
        <span className="overline">Scroll</span>
        <span className="h-10 w-px bg-white/30" />
      </div>
    </section>
  );
};

export default Hero;
